var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sending-payment" }, [
    _c("div", { staticClass: "main-container" }, [
      _c(
        "div",
        { staticClass: "center small-12" },
        [
          _c("loading-element", {
            staticClass: "loading-icon",
            attrs: { inline: "" }
          }),
          _vm._v(" "),
          _c("h2", [_vm._v(" " + _vm._s(_vm.strings.title) + " ")]),
          _vm._v(" "),
          _c("h6", [_vm._v(" " + _vm._s(_vm.strings.description) + " ")])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fd04176", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd04176","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SendingPayment.vue
// module id = null
// module chunks = 